/**
 * Tab Component
 *
 * @file tab.js
 */

import $ from "jquery";

const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const defaultTab = () => {
    const tabsBtns = document.querySelectorAll(".a-tab-item");
    const tabsContents = document.querySelectorAll(".a-tab-content");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };

  const defaultTab2 = () => {
    const tabsBtns = document.querySelectorAll(".a-tab-item2");
    const tabsContents = document.querySelectorAll(".a-tab-content2");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };

  const defaultTab3 = () => {
    const tabsBtns = document.querySelectorAll(".a-tab-item3");
    const tabsContents = document.querySelectorAll(".a-tab-content3");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };


  const defaultTabv2 = () => {
    $(".dmt-tab-v2").on("click",function(){
      $(".dmt-tab-v2").removeClass("active");
      $(this).addClass("active");
      $(".dmt-tab-content-v2").removeClass("active");
      $($(this).attr("href")).addClass("active");
      return false;
    });
  };
  const defaultTabv3 = () => {
    if($(".map-tab-item .sk-tab").is(":visible")){
      $(".dmt-tab-v3").on("click",function(){
        $(this).parent().find(".dmt-tab-v3").removeClass("active");
        $(this).addClass("active");
        $(this).parents(".map-tab-item").find(".dmt-tab-content-v3").removeClass("active");
        $($(this).attr("href")).addClass("active");
        return false;
      });
    } else{
      $(".dmt-tab-v3").on("click",function(){
        $(".dmt-tab-v3").removeClass("active");
        $(this).addClass("active");
        $(".dmt-tab-content-v3").removeClass("active");
        $($(this).attr("href")).addClass("active");
        return false;
      });
    }
  };

  const defaultTab4 = () => {
    $(".bof-list.four-item .item").on("click", function(){
      $('.board-of-directors').css('background-color', '#e9e9e9');
    });
    const namagementBtns = document.querySelectorAll(".bof-tab");
    const namagementTabsContents = document.querySelectorAll(".bof-tab-item");
    const mobileMamagementTabsContents = document.querySelectorAll(".mobile-bof-tab-content");

    for (let i = 0; i < namagementBtns.length; i++) {
      namagementBtns[i].addEventListener('click', function (event) {
        const isCurrentlyActive = namagementTabsContents[i].classList.contains('active');

        // Tüm tabları kapat
        for (let j = 0; j < namagementTabsContents.length; j++) {
          namagementTabsContents[j].classList.remove('active');
          if(mobileMamagementTabsContents){
            mobileMamagementTabsContents[j].classList.remove('active');
          }
          namagementBtns[j].classList.remove('active');
        }

        // Eğer tıklanan tab zaten açıksa, kapat; değilse aç
        if (!isCurrentlyActive) {
          namagementTabsContents[i].classList.add('active');
          if(mobileMamagementTabsContents){
            mobileMamagementTabsContents[i].classList.add('active');
          }
          namagementBtns[i].classList.add('active');
        }

        event.preventDefault();
      });
    }

    function deleteMobileDiv() {
      var mobileDiv = $(".mobile-bof-tab-content");
      if (window.innerWidth >= 768) {
        mobileDiv.remove();
      }
    }

    window.onload = deleteMobileDiv;
    window.onresize = deleteMobileDiv;
  };
  

  const init = () => {
    defaultTab();
    defaultTab2();
    defaultTabv2();
    defaultTab3();
    defaultTabv3();
    defaultTab4();
  };

  return {
    init,
  };
})();

export default tabs;
